import { atom } from "recoil";

export const ShowMergeMenuAtom = atom<boolean>({
  key: "ShowMergeMenu",
  default: false,
});
